import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PageBuilderState } from "./page-builder";
import { ModuleItemProps } from "apis";
import { store } from "store";

export type CacheState = {
    pageBuilderConfig: Record<string, PageBuilderState>;
    data: Record<string, any>;
    modules: Record<string, ModuleItemProps[]>;
    module: Record<string, ModuleItemProps>;
};

const initialState: CacheState = {
    pageBuilderConfig: {},
    data: {},
    module: {},
    modules: {}
};

interface WritePageConfigAction {
    pageId: number;
    config: PageBuilderState;
}
export const cacheSlice = createSlice({
    name: "cache",
    initialState,
    reducers: {
        writePageConfig: (state, action: PayloadAction<WritePageConfigAction>) => {
            state.pageBuilderConfig[action.payload.pageId] = action.payload.config;
        },
        writeDataConfig: (state, action: PayloadAction<{ dataKey: string; data: any }>) => {
            state.data[action.payload.dataKey] = action.payload.data;
        },
        writeModules: (state, action: PayloadAction<{ dataKey: string; data: ModuleItemProps[] }>) => {
            state.modules[action.payload.dataKey] = action.payload.data;
        },
        writeModule: (state, action: PayloadAction<{ dataKey: string; data: ModuleItemProps }>) => {
            state.module[action.payload.dataKey] = action.payload.data;
        }
    },
});

export const { writePageConfig, writeDataConfig, writeModule, writeModules } = cacheSlice.actions;
export default cacheSlice.reducer;
